import { Select as AntSelect, Form as AntForm } from 'antd';
import styled, { DefaultTheme, StyledComponent } from 'styled-components';
import { ActionPanel } from 'components/molecules/action-panel';

interface AdditionalProps {
  $width?: number;
}

export const Select = styled(AntSelect).attrs<AdditionalProps>({
  bordered: false,
  placeholder: 'Select...',
  autoFocus: true,
})`
  --select-spacing: var(--spacing-05);
  background: var(--coolest-gray-20);

  .ant-select-selector {
    padding: 0 var(--select-spacing);
  }

  .ant-select-arrow {
    right: calc(var(--select-spacing) / 2);
  }

  .ant-select-selection-item {
    width: ${(props) =>
      `${(props as unknown as AdditionalProps).$width ?? 24}px`};
  }
` as StyledComponent<typeof AntSelect, DefaultTheme, AdditionalProps, never>;

export const Form = styled(AntForm)``;

export const Popover = styled(ActionPanel.Popover)`
  ${Form} {
    margin: 0 var(--popover-spacing);

    .ant-form-item {
      margin-right: var(--popover-spacing);

      &:last-child {
        margin: 0;
      }
    }
  }
`;
